import React, { useEffect, useState } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import TableContainer from '@mui/material/TableContainer';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import Box from '@mui/material/Box';
import axios from 'axios';
import DownloadIcon from '@mui/icons-material/Download';
import IconButton from '@mui/material/IconButton';
import { Typography } from '@mui/material';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import TextField from '@mui/material/TextField';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';

import InvoicePreview from './InvoicePreview';
import OrderCancel from 'components/Coupon/OrderCancel';

export default function TaxBillDetail(props) {
  const { open, handleClose, getDataList, page, companyId, orderId } = props;

  const [taxBillInfo, setTaxBillInfo] = useState({});
  const [openInvoice, setOpenInvoice] = useState(false);
  const [openCompanion, setOpenCompanion] = useState(false);
  const [openCancel, setOpenCancel] = useState(false);
  const [orderStepCdItem, setOrderStepCdItem] = useState([]);

  /**
   * 회계팀 세금계산서 요청 메일 발송
   * @param {*} id
   */
  const handleClickRequestTaxBill = async (id) => {
    if (!taxBillInfo?.isFileInvoice) {
      alert('세금계산서 내역을 확인하고 Invoice를 생성하세요.');
      return;
    }

    if (window.confirm('확인을 누르시면 회계팀으로 세금계산서 요청 메일이 전송됩니다. 세금계산서 발행 완료 후 구매자에게 통장사본 및 인보이스를 송부하세요.')) {
      await axios
        .patch(`/api/coupon/request-tax-bill/${orderId}`)
        .then((response) => {
          alert(response.data.message);
          getDataList(page, 'N');
          handleClose();
        })
        .catch((error) => {
          alert(error.response.data.message);
        });
    }
  };

  /**
   * 회계팀 세금계산서 요청 메일 발송
   * @param {*} id
   */
  const handleClickRequestTaxBillRe = async (id) => {
    if (!taxBillInfo?.isFileInvoice) {
      alert('세금계산서 내역을 확인하고 Invoice를 생성하세요.');
      return;
    }

    if (window.confirm('확인을 누르시면 회계팀으로 세금계산서 요청 메일이 전송됩니다. 세금계산서 발행 완료 후 구매자에게 통장사본 및 인보이스를 송부하세요.')) {
      await axios
        .patch(`/api/coupon/request-tax-bill/${orderId}`, { type: 're' })
        .then((response) => {
          alert(response.data.message);
        })
        .catch((error) => {
          alert(error.response.data.message);
        });
    }
  };

  /**
   * 세금계산서 발행 확인 후 주문상태 업데이트를 통해 사용자>사용권관리 목록에서 [입금완료] 버튼 활성화
   * @param {*} id
   */
  const issuance = async (id) => {
    if (window.confirm('확인을 누르시면 사용권관리>입금확인 버튼이 활성화 됩니다.')) {
      await axios
        .patch(`/api/coupon/issuance/${orderId}`)
        .then((response) => {
          alert(response.data.message);
          getDataList(page, 'N');
          getTaxBillInfo();
        })
        .catch((error) => {
          alert(error.response.data.message);
        });
      await axios.patch(`/api/coupon/post-invoice/${orderId}`).catch((error) => {
        alert(error.response.data.message);
      });
    }
  };

  const approval = async (id) => {
    if (window.confirm('확인을 누르시면 사용권 생성이 됩니다.')) {
      await axios
        .patch(`/api/coupon/approval/${orderId}`)
        .then((response) => {
          alert(response.data.message);
          getDataList(page, 'N');
          getDataList(page, 'Y');
          handleClose();
        })
        .catch((error) => {
          alert(error.response.data.message);
        });
    }
  };

  /**
   * 반려 시 사유 입력 후 취소 처리
   * @param {*} id
   */
  const companion = async (e) => {
    const result = window.prompt('반려 사유를 입력하세요.');
    if (result) {
      await axios
        .patch(`/api/coupon/companion/${orderId}`, { companionReason: result })
        .then((response) => {
          alert(response.data.message);
          getTaxBillInfo();
        })
        .catch((error) => {
          alert(error.response.data.message);
        });
    }
  };

  const handleClickCancel = async (e) => {
    e.stopPropagation();
    setOpenCancel(true);
  };

  const handleClickCancelCmpt = async (e) => {
    if (window.confirm('해당 주문을 취소하고 구매자에게 주문취소완료 알림 메일을 전송하시겠습니까?')) {
      await axios
        .patch(`/api/coupon/cancel-complete/${orderId}`)
        .then((response) => {
          alert(response.data.message);
          getDataList(1);
          handleClose();
        })
        .catch((error) => {
          alert(error.response.data.message);
        });
    }
  };

  const handleClickPostInvoice = async (e) => {
    if (window.confirm('확인을 누르시면 구매자에게 통장사본 및 인보이스를 발송합니다. 전송하시겠습니까?')) {
      await axios
        .patch(`/api/coupon/post-invoice/${orderId}`)
        .then((response) => {
          alert(response.data.message);
          getDataList(page, 'N');
          handleClose();
        })
        .catch((error) => {
          alert(error.response.data.message);
        });
    }
  };

  const getTaxBillInfo = async () => {
    try {
      const response = await axios.get(`/api/coupon/order-tax-bill/${orderId}`);
      if (response?.data) {
        setTaxBillInfo(response.data?.couponOrder);
      }
    } catch (e) {
      console.log('세금계산서 정보를 불러오지 못했습니다.');
    }
  };

  const fileDown = async (params) => {
    const { fileName, orderNo } = params;
    const response = await axios.get(`/api/file-smtp`, { params: { fileName, orderNo }, responseType: 'blob' });
    if (response.data.error) {
      console.error(response.data.error);
      alert('다운로드 실패!');
    } else {
      const fileURL = window.URL.createObjectURL(new Blob([response.data]));
      const fileLink = document.createElement('a');
      fileLink.href = fileURL;
      const fileOriginName = response.headers['content-disposition'].split('filename=')[1];
      fileLink.setAttribute('download', fileOriginName.replace(/"/g, ''));
      fileLink.setAttribute('target', '_blank');
      document.body.appendChild(fileLink);
      fileLink.click();
      fileLink.remove();
    }
  };

  /**
   * 사업자등록증 다운로드
   * @param {*} e
   */
  const handleClickDownloadRegist = async (e) => {
    const fileName = taxBillInfo?.fileName;
    const orderNo = taxBillInfo?.orderNo;
    await fileDown({ fileName, orderNo });
  };

  /**
   * 세금계산서 다운로드
   * @param {*} e
   */
  const handleClickDownloadTaxBill = async (e) => {
    const fileName = `${taxBillInfo?.orderNo}.xlsx`;
    const orderNo = taxBillInfo?.orderNo;
    await fileDown({ fileName, orderNo });
  };

  /**
   * 인보이스 다운로드
   * @param {*} e
   */
  const handleClickDownloadInvoice = async (e) => {
    const fileName = `${taxBillInfo?.orderNo}.pdf`;
    const orderNo = taxBillInfo?.orderNo;
    await fileDown({ fileName, orderNo });
  };

  const getOrderStepCd = async () => {
    const response = await axios.get('/api/code/order_step');
    if (response.data) {
      setOrderStepCdItem(response.data);
    }
  };

  /**
   * 주문확인
   * @param {*} e
   */
  const handleOrderConfirm = async (e) => {
    if (window.confirm('주문정보를 확인했습니까? 사용권 구매 주문을 승인합니다.')) {
      await axios
        .patch(`/api/coupon/order-confirm/${orderId}`)
        .then((response) => {
          alert(response.data.message);
          getDataList(1);
          getTaxBillInfo();
        })
        .catch((error) => {
          alert(error.response.data.message);
        });
    }
  };

  /**
   * 인보이스 미리보기
   * @param {*} e
   */
  const handleOpenInvoice = async (e) => {
    setOpenInvoice(true);
  };

  const handleOpenCompanion = async (e) => {
    setOpenCompanion(true);
  };

  useEffect(() => {
    if (open && orderId) {
      getTaxBillInfo();
      getOrderStepCd();
    }
  }, [open, orderId]);

  useEffect(() => {
    if (!openInvoice && open && orderId) {
      getTaxBillInfo();
    }
  }, [openInvoice]);

  return (
    <Dialog open={open} onClose={handleClose} aria-labelledby="draggable-dialog-title" maxWidth={'lg'}>
      <DialogTitle id="draggable-dialog-title">사용권구매 진행상황</DialogTitle>
      <DialogContent dividers sx={{ height: 600 }}>
        <Box sx={{ m: 4 }}>
          <Typography>세금계산서 신청 내역</Typography>
          <TableContainer component={'div'}>
            <Table>
              <TableBody>
                <TableRow>
                  <TableCell>주문번호</TableCell>
                  <TableCell>{taxBillInfo?.orderNo}</TableCell>
                  <TableCell>회사명</TableCell>
                  <TableCell>{taxBillInfo?.acCompanyName}</TableCell>
                  <TableCell>사업자 등록번호</TableCell>
                  <TableCell>{taxBillInfo?.acCompanyNo}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>이름</TableCell>
                  <TableCell>{taxBillInfo?.acUserName}</TableCell>
                  <TableCell>전화번호</TableCell>
                  <TableCell>{taxBillInfo?.accountantPhone}</TableCell>
                  <TableCell>이메일</TableCell>
                  <TableCell>{taxBillInfo?.accountantEmail}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>사업자등록증</TableCell>
                  {taxBillInfo?.isFileRegist ? (
                    <TableCell>
                      {taxBillInfo?.isFileRegist && `${taxBillInfo?.fileNameOrigin}`}
                      <IconButton aria-label="down" onClick={handleClickDownloadRegist}>
                        <DownloadIcon />
                      </IconButton>
                    </TableCell>
                  ) : (
                    <TableCell>-</TableCell>
                  )}
                  <TableCell>세금계산서</TableCell>
                  {taxBillInfo?.isFileTaxbill ? (
                    <TableCell>
                      {taxBillInfo?.isFileTaxbill && `${taxBillInfo?.orderNo}.xlsx`}
                      <IconButton aria-label="down" onClick={handleClickDownloadTaxBill}>
                        <DownloadIcon />
                      </IconButton>
                    </TableCell>
                  ) : (
                    <TableCell>-</TableCell>
                  )}
                  <TableCell>Invoice</TableCell>
                  <TableCell>
                    {taxBillInfo?.isFileInvoice && `${taxBillInfo?.orderNo}.pdf`}
                    {taxBillInfo?.isFileInvoice && (
                      <IconButton aria-label="down" onClick={handleClickDownloadInvoice}>
                        <DownloadIcon />
                      </IconButton>
                    )}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell colSpan={2}>주문정보: </TableCell>
                  <TableCell>사용권수량</TableCell>
                  <TableCell>{taxBillInfo?.quantity}</TableCell>
                  <TableCell>잔여수량</TableCell>
                  <TableCell>{taxBillInfo?.residualQuantity === null ? '생성된 사용권 없음' : Number(taxBillInfo?.residualQuantity)}</TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
        {(taxBillInfo?.quantity === taxBillInfo?.residualQuantity || taxBillInfo?.residualQuantity === null || taxBillInfo?.issuanceAt === null) && (
          <Box sx={{ m: 4 }} display="flex">
            <Button variant="contained" onClick={handleOpenCompanion} sx={{ width: 120, mr: 2 }} color="warning" disabled={['800', 'CANCEL_CMPT'].includes(taxBillInfo?.prgStepCd)}>
              반려
            </Button>
            <Button variant="contained" onClick={handleClickCancel} sx={{ width: 120, mr: 2 }} disabled={taxBillInfo?.prgStepCd === 'CANCEL_CMPT'} color="error">
              주문취소
            </Button>
            {taxBillInfo.cancelReqAt && (
              <Button variant="contained" onClick={handleClickCancelCmpt} sx={{ width: 120 }} disabled={taxBillInfo?.prgStepCd === 'CANCEL_CMPT'}>
                주문취소완료
              </Button>
            )}
            {taxBillInfo.cancelReqAt && <Typography sx={{ ml: 2, mt: 1 }}>* 취소사유 : {taxBillInfo?.cancelReason}</Typography>}
          </Box>
        )}
        <Box sx={{ mx: 4 }}>
          <Breadcrumbs separator={<NavigateNextIcon fontSize="large" />} aria-label="breadcrumb">
            {orderStepCdItem.map((item) => {
              const prgStepCd = item?.cdVal;
              const activeCode = taxBillInfo?.prgStepCd;
              if (prgStepCd === '001' && activeCode === '001') {
                return <ActiveBtn prgStepNm="주문요청" label="주문요청" activeStep={activeCode} prgStepCd={prgStepCd} isEvent={true} />;
              }
              if (prgStepCd === '002' && activeCode !== '001') {
                return <ActiveBtn prgStepNm="주문확인" label="주문확인" onClick={handleOrderConfirm} activeStep={activeCode} prgStepCd={prgStepCd} />;
              }
              if (prgStepCd === '003') {
                return (
                  <ActiveBtn
                    prgStepNm="인보이스생성"
                    label={
                      <>
                        세금계산서 <br /> 발행요청
                      </>
                    }
                    onClick={handleClickRequestTaxBill}
                    activeStep={activeCode}
                    prgStepCd={prgStepCd}
                  />
                );
              }
              if (prgStepCd === '100') {
                return (
                  <ActiveBtn
                    prgStepNm="세금계산서 발행요청"
                    label={
                      <>
                        세금계산서 발행
                        <br />
                        (입금요청)
                      </>
                    }
                    onClick={issuance}
                    activeStep={activeCode}
                    prgStepCd={prgStepCd}
                  />
                );
              }
              if (prgStepCd === '200' && activeCode === '200') {
                return <ActiveBtn prgStepNm="세금계산서 발행완료" label="입금대기중" activeStep={activeCode} prgStepCd={prgStepCd} isEvent={true} />;
              }
              if (prgStepCd === '200' && activeCode !== '200') {
                return <ActiveBtn prgStepNm="세금계산서 발행완료" label="입금완료" activeStep={activeCode} prgStepCd={prgStepCd} isEvent={true} />;
              }
              if (prgStepCd === '201' && activeCode !== '800') {
                return <ActiveBtn prgStepNm="입금확인" label="입금확인" onClick={approval} activeStep={activeCode} prgStepCd={prgStepCd} />;
              }
              if (prgStepCd === '800' && activeCode === '800') {
                return <ActiveBtn prgStepNm="코드발급완료" label="코드발급완료" activeStep={activeCode} prgStepCd={prgStepCd} isEvent={true} />;
              }
            })}
          </Breadcrumbs>
        </Box>
        <Box sx={{ mx: 4, mt: 1 }} display="flex" justifyContent="center">
          <Breadcrumbs separator={<NavigateNextIcon fontSize="large" sx={{ color: 'white' }} />} aria-label="breadcrumb">
            {orderStepCdItem.map((item) => {
              const prgStepCd = item?.cdVal;
              const activeCode = taxBillInfo?.prgStepCd;
              if (prgStepCd === '001' && activeCode === '001') {
                return <ActiveSubBtn prgStepNm="주문요청" label="인보이스 생성하기" onClick={handleOpenInvoice} activeStep={activeCode} prgStepCd={prgStepCd} />;
              }
              if (prgStepCd === '002' && activeCode !== '001') {
                return <ActiveSubBtn prgStepNm="주문확인" label="인보이스 미리보기" onClick={handleOpenInvoice} activeStep={activeCode} prgStepCd={prgStepCd} />;
              }
              if (prgStepCd === '003') {
                return (
                  <ActiveSubBtn
                    prgStepNm="인보이스생성"
                    label={
                      <>
                        세금계산서 <br /> 재요청
                      </>
                    }
                    onClick={handleClickRequestTaxBillRe}
                    activeStep={activeCode}
                    prgStepCd={prgStepCd}
                  />
                );
              }
              if (prgStepCd === '100') {
                return <ActiveSubBtn prgStepNm="세금계산서 발행요청" label="인보이스 재전송" onClick={handleClickPostInvoice} activeStep={activeCode} prgStepCd={prgStepCd} />;
              }
              if (prgStepCd === '200' && activeCode === '200') {
                return <ActiveSubBtn prgStepNm="세금계산서 발행완료" label="" activeStep={activeCode} prgStepCd={prgStepCd} isEvent={true} />;
              }
              if (prgStepCd === '200' && activeCode !== '200') {
                return <ActiveSubBtn prgStepNm="세금계산서 발행완료" label="" activeStep={activeCode} prgStepCd={prgStepCd} isEvent={true} />;
              }
              if (prgStepCd === '201' && activeCode !== '800') {
                return <ActiveSubBtn prgStepNm="입금확인" label="" onClick={companion} activeStep={activeCode} prgStepCd={prgStepCd} isEvent={true} />;
              }
              if (prgStepCd === '800' && activeCode === '800') {
                return <ActiveSubBtn prgStepNm="코드발급완료" label="" onClick={approval} activeStep={activeCode} prgStepCd={prgStepCd} isEvent={true} />;
              }
            })}
          </Breadcrumbs>
        </Box>
        <InvoicePreview open={openInvoice} setOpenInvoice={setOpenInvoice} orderNo={taxBillInfo?.orderNo} getDataList={getDataList} />
        <CompanionView open={openCompanion} setOpenCompanion={setOpenCompanion} pDatas={taxBillInfo} prgStepCdItem={orderStepCdItem} getTaxBillInfo={getTaxBillInfo} />
        <OrderCancel open={openCancel} handleClose={(e) => setOpenCancel(false)} pDatas={taxBillInfo} getDataList={getDataList} parentClose={handleClose} />
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" color="success" onClick={handleClose}>
          닫기
        </Button>
      </DialogActions>
    </Dialog>
  );
}

const ActiveBtn = (props) => {
  const { onClick, activeStep, prgStepCd, label, isEvent } = props;

  /**
   * 현재 단계 및 이전 단계 활성화. 이후 단계는 비활성화
   * @param {*} activeStep 현재 진행단계
   * @param {*} currentPrgStep 활성화를 위한 이전단계 코드
   * @returns
   */
  const isDisabled = (activeStep, prevPrgStep) => {
    let isVisible = true;
    if (Number(activeStep) >= Number(prevPrgStep)) {
      isVisible = false;
    }
    return isVisible;
  };

  /**
   * 현재 단계 및 이전 단계 활성화. 이후 단계는 비활성화
   * @param {*} activeStep 현재 진행단계
   * @param {*} currentPrgStep 버튼클릭 활성화를 위한 진행단계코드
   * @returns
   */
  const getStyle = (activeStep, prevPrgStep) => {
    const isActiveStep = Number(activeStep) === Number(prevPrgStep);
    let props = { sx: { width: 160, height: 100, pointerEvents: 'none' }, color: 'info' };
    if (isActiveStep && !isEvent) {
      props = { sx: { width: 160, height: 100 }, color: 'primary' };
    }
    return props;
  };

  return (
    <Button variant="contained" onClick={onClick} disabled={isDisabled(activeStep, prgStepCd)} {...getStyle(activeStep, prgStepCd)}>
      {label}
    </Button>
  );
};
const ActiveSubBtn = (props) => {
  const { onClick, activeStep, prgStepCd, label, isEvent, color } = props;

  /**
   * 현재 단계 및 이전 단계 활성화. 이후 단계는 비활성화
   * @param {*} activeStep 현재 진행단계
   * @param {*} currentPrgStep 활성화를 위한 이전단계 코드
   * @returns
   */
  const isDisabled = (activeStep, prevPrgStep) => {
    let isVisible = true;
    if (Number(activeStep) >= Number(prevPrgStep)) {
      isVisible = false;
    }
    return isVisible;
  };

  return (
    <Button variant={isEvent ? 'text' : 'outlined'} onClick={onClick} disabled={isEvent || isDisabled(activeStep, prgStepCd)} sx={{ width: 160, height: 50 }} color={color || 'primary'}>
      {label}
    </Button>
  );
};

const CompanionView = (props) => {
  const { pDatas, open, setOpenCompanion, getDataList, prgStepCdItem, getTaxBillInfo } = props;

  const [companionReason, setCompanionReason] = useState('');
  const [prgStepCd, setPrgStepCd] = useState('200');

  const handleClickCompanion = async (e) => {
    const { id } = pDatas;
    await axios
      .patch(`/api/coupon/companion/${id}`, { prgStepCd, companionReason })
      .then((response) => {
        alert(response.data.message);
        getTaxBillInfo();
        handleClose();
        getDataList();
      })
      .catch((error) => {
        alert(error.response.data.message);
      });
  };
  const handleChangeSelect = (e) => {
    setPrgStepCd(e.target.value);
  };

  const handleClose = (e) => {
    setOpenCompanion(false);
  };

  return (
    <Dialog open={open} onClose={handleClose} aria-labelledby="draggable-dialog-title">
      <DialogTitle id="draggable-dialog-title">주문 반려 처리</DialogTitle>
      <DialogContent dividers>
        <Box sx={{ display: 'block' }}>
          <TableContainer component={'div'}>
            <Table size="small">
              <TableRow>
                <TableCell>현재진행단계</TableCell>
                <TableCell align="right">{pDatas?.prgStepNm}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>변경단계</TableCell>
                <TableCell>
                  <Select id="prgStepCd" name="prgStepCd" value={prgStepCd} onChange={handleChangeSelect} sx={{ width: 300 }} size="small">
                    {prgStepCdItem.map((item) => {
                      return <MenuItem value={item.cdVal}>{item.cdNm}</MenuItem>;
                    })}
                  </Select>
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell colSpan={2}>
                  <TextField placeholder="반려 사유를 입력해주세요." size="small" sx={{ width: '100%' }} multiline rows={2} value={companionReason} onChange={(e) => setCompanionReason(e.target.value)} />
                </TableCell>
              </TableRow>
            </Table>
          </TableContainer>
          <Typography sx={{ mt: 2, mx: 4 }}>주문 단계를 변경하시겠습니까? </Typography>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button variant="contained" onClick={handleClickCompanion}>
          예
        </Button>
        <Button variant="outlined" onClick={handleClose}>
          아니오
        </Button>
      </DialogActions>
    </Dialog>
  );
};
